export const headerWithAuthToken = (headers) => {
  const token = JSON.parse(localStorage.getItem("token"));
  if (token) {
    headers.set("Authorization", token);
  }
  headers.set("Content-Type", "application/json");
  return headers;
};
